import React, { forwardRef, memo } from 'react'

const DividerWithStars = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    width="1115.1"
    height="47.6"
    viewBox="0 0 1593 68"
    fill="none"
    {...props}>
    <path d="M0 34h1593" stroke="#EEE" strokeWidth={3.227} />
    <path
      d="M174.118 0 169.653 21.843a8.12 8.12 0 0 1-7.575 7.575l-21.843 4.465 21.843 4.464a8.12 8.12 0 0 1 7.575 7.576l4.465 21.842 4.464-21.842a8.12 8.12 0 0 1 7.576-7.576l21.843-4.464-21.843-4.465a8.12 8.12 0 0 1-7.576-7.575L174.118 0Z"
      fill="#78BE20"
    />
    <path
      d="M722.118 0 717.653 21.843a8.12 8.12 0 0 1-7.575 7.575l-21.843 4.465 21.843 4.464a8.12 8.12 0 0 1 7.575 7.576l4.465 21.842 4.464-21.842a8.12 8.12 0 0 1 7.576-7.576l21.843-4.464-21.843-4.465a8.12 8.12 0 0 1-7.576-7.575L722.118 0Z"
      fill="#78BE20"
    />
    <path
      d="M1354.12 0 1349.65 21.843a8.12 8.12 0 0 1-7.56 7.575l-21.84 4.465 21.84 4.464a8.12 8.12 0 0 1 7.56 7.576l4.47 21.842 4.46-21.842a8.12 8.12 0 0 1 7.58-7.576l21.84-4.464-21.84-4.465a8.12 8.12 0 0 1-7.58-7.575L1354.12 0Z"
      fill="#78BE20"
    />
  </svg>
))

DividerWithStars.displayName = 'DividerWithStars'
export default memo(DividerWithStars)
